module.exports = __webpack_public_path__ + "img/others-frame.1db1ba4d.gif";